"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "pruneCache", {
    enumerable: true,
    get: function() {
        return pruneCache;
    }
});
const _workspacetools = require("workspace-tools");
const _config = require("@lage-run/config");
const _cache = require("@lage-run/cache");
async function pruneCache(options) {
    const { logger, cwd, pruneDays } = options;
    const config = await (0, _config.getConfig)(cwd);
    const workspaceRoot = (0, _workspacetools.getWorkspaceRoot)(cwd);
    const concurrency = (0, _config.getConcurrency)(options.concurrency, config.concurrency);
    if (!workspaceRoot) {
        return;
    }
    const prunePeriod = pruneDays || 30;
    const cacheProvider = new _cache.BackfillCacheProvider({
        root: cwd,
        cacheOptions: config.cacheOptions,
        logger
    });
    // eslint-disable-next-line no-console
    console.log("Clearing Cache");
    cacheProvider.purge(prunePeriod, concurrency);
    // eslint-disable-next-line no-console
    console.log("Cache Cleared");
}
